const STORAGE_KEY = "eyecatcher_user";

export interface UserState {
  bestScore: number;
  boostTicketsRemaining: number;
  boostClaimCount: number; // max 3
  selectedFXTheme: string;
}

function defaultUserState(): UserState {
  return {
    bestScore: 0,
    boostTicketsRemaining: 0,
    boostClaimCount: 0,
    selectedFXTheme: "default",
  };
}

export function loadUserState(): UserState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      return { ...defaultUserState(), ...JSON.parse(raw) };
    }
  } catch {
    // ignore
  }
  return defaultUserState();
}

export function saveUserState(state: UserState): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}
